// extracted by mini-css-extract-plugin
export default {"navContainer":"SelectionMenu_navContainer__kGPJr","menuList":"SelectionMenu_menuList__AgsMP","menuItem":"SelectionMenu_menuItem__FHzNb"};